import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BUYER_DETAILS_ROUTE } from '../shared/constants/routes';
import { BuyerDetailsComponent } from './buyer-details/buyer-details.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  {
    path: `${BUYER_DETAILS_ROUTE}/:buyer_id`,
    component: BuyerDetailsComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuyerDetailsRoutingModule {}
